module.exports = __webpack_public_path__ + "img/scoreLow.6dd156d7.png";